import React from "react";

import Bin from "../FormComponent/Bin";

const SectionTitle = (props) => {
  return (
    <div className="section-header pt-6 pl-6 d-flex">
      <div>
        <label>Group Title*</label>       
        <input
          type="text"
          name="Title"
          maxLength="50"
          placeholder="Section Name"
          value={props.tabSec.sectionTitle}
          onChange={props.changeNameHandler}
          className={props.error[props.tabSec.sectionId] ? "error-input" : ""}
        />
        {props.error[props.tabSec.sectionId] && (
          <label className="error">Mandatory Field.</label>
        )}
      </div>
      {props.index > 0 ? (
        <Bin deleteHandler={props.deleteSectionHandler} isSection={true} />
      ) : null}
    </div>
  );
};

export default SectionTitle;
